
import { Vue, Component, Prop } from "vue-property-decorator";
import Spinner from '@/components/common/Spinner.vue';

@Component({
  components: {
    Spinner,
  },
})
export default class Processing extends Vue {
  @Prop({ type: Boolean, default: false }) readonly spinner!: boolean;
  @Prop({ type: Boolean, default: false }) readonly processing!: boolean;
  @Prop({ type: Number, default: 50 }) readonly backgroundOpacity!: number;
  @Prop({ type: String, default: undefined }) readonly overlayBlockClasses!: string;

  get opacity():string {
    return `opacity-${this.backgroundOpacity}`;
  }
}
